import Image from 'next/image';
import { motion, type HTMLMotionProps } from 'framer-motion';

import { cn } from '#/lib/utils';

import image from './images/diamond.png';

export function Diamond({ className, ...props }: HTMLMotionProps<'div'>) {
  return (
    <motion.div {...props} className={cn(className)} data-name="diamond">
      <Image {...image} alt="Diamond" className="w-full h-full object-cover" />
    </motion.div>
  );
}
